<script lang="ts">
  import type { PackageModel, SessionLightModel, SessionModel } from '@24hbs/utils';
  import { getDisplayedPrice, getDisplayedPriceForcedIva } from '$lib/utils/price-utils';

  export let sessionPackage: PackageModel;
  export let session: SessionModel | SessionLightModel;
  export let hasVatFree: boolean;
  export let tabletMobile: boolean = false;
  export let showPriceWithIva: boolean = false;
</script>

<div class="package-price" class:tabletMobile>
  {#if showPriceWithIva}
    {#if sessionPackage.discountPrice > 0}
      <div class="deleted-price">{getDisplayedPriceForcedIva('original', hasVatFree, session, sessionPackage)}*</div>
      <div class="price">{getDisplayedPriceForcedIva('discount', hasVatFree, session, sessionPackage)}*</div>
    {:else}
      <div class="price">{getDisplayedPriceForcedIva('original', hasVatFree, session, sessionPackage)}*</div>
    {/if}
  {:else}
    {#if sessionPackage.discountPrice > 0}
      <div class="deleted-price">{getDisplayedPrice('original', hasVatFree, session, sessionPackage)}</div>
      <div class="price">{getDisplayedPrice('discount', hasVatFree, session, sessionPackage)}</div>
    {:else}
      <div class="price">{getDisplayedPrice('original', hasVatFree, session, sessionPackage)}</div>
    {/if}
  {/if}
</div>

<style type="text/scss" lang="scss" scoped>
  .package-price {
    @apply py-4;
    @apply mx-auto;
    @apply text-center;

    .deleted-price {
      @apply text-lg line-through	text-gray-600;
    }
    .price {
      @apply text-xl;
    }
  }

  .tabletMobile.package-price {
    @apply text-right;

    .deleted-price {
      @apply text-base line-through	text-gray-600;
    }
    .price {
      @apply text-xl;
    }
  }
</style>
